import { useLocation, useParams } from 'react-router-dom';

import { PAGES } from 'consts/pages';

const useCurrentPage = () => {
  const params = useParams();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const view = searchParams.get('view');
  if (params.page === 'detections' && view === 'intel-events') {
    return PAGES.events;
  }

  if (location.pathname.includes(PAGES.notifications)) {
    return PAGES.notifications;
  }
  switch (params.page) {
    case 'overview':
      return PAGES.alerts;
    case 'investigator':
    case 'logs':
      return PAGES.investigator;
    case 'identity-management':
      return PAGES.identityManagement;
    default:
      return params.page;
  }
};

export default useCurrentPage;
